import { AlertTriangle } from 'lucide-react';
import { useSessionExpiryWarning } from '../../hooks/useSessionExpiryWarning';

/**
 * TASK-393: non-blocking banner shown on the meeting screens when the session
 * token is about to expire. Prompts the advisor to save + re-login before the
 * 401 interceptor forces a redirect and drops in-progress work.
 */
export function SessionExpiryBanner() {
  const { expiringSoon, minutesLeft } = useSessionExpiryWarning();

  if (!expiringSoon) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-amber-50 border-b border-amber-200 text-sm text-amber-800 flex-shrink-0">
      <AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <span>
        Your session expires in {minutesLeft} min — save your work and{' '}
        <a href="/login" className="font-medium underline hover:text-amber-900">
          re-login
        </a>{' '}
        to avoid losing changes.
      </span>
    </div>
  );
}

export default SessionExpiryBanner;
